import * as React from 'react';

import styled from '../../theme';
import { IRenderProps } from '../../models/ProjectType';
import { Link } from 'react-router-dom';

const Container = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -52.5%);
  text-align: center;
  user-select: none;
`;

const LinkContainer = styled.div`
  display: block;
  cursor: pointer;
  margin-bottom: 30vmin;

  @media (min-width: 768px) {
    margin-bottom: 7vmin;
  }

  &:last-child {
    margin-bottom: 0;
  }

  a {
    color: #efd5a1;
    text-decoration: none;
    letter-spacing: -0.8vw;
    font-size: 9.5vw;
    display: block;
    transition: 0.7s linear transform;
    will-change: transform;
  }
`;

const slugOrderMap = {
  curatorial: 0,
  commission: 1,
  personal: 2,
};

const slugSpeedMap = {
  curatorial: 6,
  commission: 2,
  personal: 4,
};

function getRandomInt(min: number, max: number) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function getMobileOperatingSystem() {
  const userAgent = navigator.userAgent || navigator.vendor;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return 'Windows Phone';
  }

  if (/android/i.test(userAgent)) {
    return 'Android';
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent)) {
    return 'iOS';
  }

  return 'unknown';
}

const os = getMobileOperatingSystem();

class MovingLink extends React.PureComponent<{
  url: string;
  text: string;
  index: number;
  speed: number;
}> {
  componentDidMount() {
    window.addEventListener('devicemotion', this.handleDeviceMotion);
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    this.rotationTick = setInterval(() => {
      this.rotation = this.rotation;
    }, 5000);
  }

  componentWillUnmount() {
    clearInterval(this.rotationTick);
    window.removeEventListener('devicemotion', this.handleDeviceMotion);
    window.removeEventListener('resize', this.handleResize);
  }

  private rotationTick: NodeJS.Timer;

  private rotation = getRandomInt(-45, 45);
  private x = 0;
  private y = 0;
  private initialX = 0;
  private initialY = 0;
  private boundX = 0;
  private boundY = 0;
  private height = 0;
  private width = 0;

  handleResize = () => {
    requestAnimationFrame(() => {
      if (this.el) {
        const rect = this.el.getBoundingClientRect();
        this.initialX = rect.left;
        this.initialY = rect.top;
        this.height = rect.height;
        this.width = rect.width;
      }

      this.boundX = window.innerWidth;
      this.boundY = window.innerHeight;
    });
  };

  handleDeviceMotion = (e: any) => {
    let { y } = e.accelerationIncludingGravity;
    const { x } = e.accelerationIncludingGravity;
    const { speed } = this.props;

    let nextY: number;
    let nextX: number;
    switch (os) {
      case 'Android':
        y -= 6;
        nextY = this.y + y / speed;
        nextX = this.x - x / speed;

        break;

      default:
        nextY = this.y - y / speed;
        nextX = this.x + x / speed;

        break;
    }

    if (nextX >= -this.initialX && nextX + this.width <= this.boundX) {
      this.x = nextX;
    }
    if (
      nextY > -this.initialY &&
      nextY < this.boundY - this.initialY - this.height
    ) {
      this.y = nextY;
    }

    requestAnimationFrame(() => {
      const transform = `translate(${this.x}px, ${this.y}px) rotate(${
        this.rotation
      }deg)`;

      if (this.el) {
        this.el.style.transform = transform;
      }
    });
  };

  private el?: HTMLElement;

  render() {
    return (
      <Link to={this.props.url} innerRef={ref => (this.el = ref!)}>
        {this.props.text}
      </Link>
    );
  }
}

export default class ProjectTypeSelection extends React.PureComponent<
  IRenderProps
> {
  state = {
    arrowOffset: 0,
    hoveredIndex: 0,
  };

  render() {
    const { data } = this.props;

    return (
      <Container>
        {data.items
          .sort((a, b) => {
            return slugOrderMap[a.fields.slug] - slugOrderMap[b.fields.slug];
          })
          .map((item, index) => (
            <LinkContainer key={item.fields.slug}>
              <MovingLink
                url={`/project/${item.fields.slug}`}
                text={`${item.fields.name}Projects`}
                index={index}
                speed={slugSpeedMap[item.fields.slug]}
              />
            </LinkContainer>
          ))}
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Home/ProjectTypeSelectorMobile.tsx